import { IRoleRepository } from "domain/contracts/role.contract";
import { Message } from "../../domain/entities/message";
import { httpClient } from "../axios/axios-api";
import { BaseInputFilter } from "domain/models/base-input-filter";
import { Role } from "domain/entities/role";

class RoleRepository implements IRoleRepository {
  async delete(id: string): Promise<Message<boolean>> {
    const response = await httpClient.delete(`/role/${id}`);
    return response.data;
  }

  async create(input: Role): Promise<Message<Role>> {
    const response = await httpClient.post(`/role`, { data: input });
    return response.data;
  }

  async update(input: Role): Promise<Message<boolean>> {
    const response = await httpClient.put(`/role/${input.id}`, {
      data: input,
    });
    return response.data;
  }

  async getAll(filter: BaseInputFilter): Promise<Message<Role[]>> {
    const response = await httpClient.get(`/role`, { params: filter });
    return response.data;
  }

  async getById(id: string): Promise<Message<Role>> {
    const response = await httpClient.get(`/role/${id}`);
    return response.data;
  }
}

export default new RoleRepository();
